import React from "react";
import { makeStyles, Theme, createStyles, MenuItem } from "@material-ui/core";
import { observer } from "mobx-react";
import { StubOrganizationVolunteer } from "../../../../../../stores/models/StubOrganizationVolunteer";
import REMSelect from "../../../../../../shared/modules/rem-conversion/components/Select";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        dropdown: {
            display: 'flex'
        }
    })
);

interface MultipleChoiceFieldProps extends React.HTMLAttributes<HTMLDivElement> {
    volunteer: StubOrganizationVolunteer;
    options: { id: number, option: string }[];
}

const MultipleChoiceField = observer((props: MultipleChoiceFieldProps) => {

    const classes = useStyles();

    /********** Event Handlers *********/

    const onSelectedStatusChanged = (event: React.ChangeEvent<{
        name?: string | undefined;
        value: unknown;
    }>, child: React.ReactNode) => {
        props.volunteer.setRegistrationFormStatusId(event.target.value as number);
    }

    /********** Render *********/

    return (
        <REMSelect
            value={props.volunteer.registrationFormStatusId}
            variant={'outlined'}
            onChange={(event, child) => onSelectedStatusChanged(event, child)}
            className={classes.dropdown}
        >
            {props.options.map(option => {
                return (
                    <MenuItem value={option.id} key={option.id}>{option.option}</MenuItem>
                )
            })}
        </REMSelect>
    )
});

export default MultipleChoiceField;